import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'pwj-filters-section-heading',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './filters-section-heading.component.html',
  styleUrl: './filters-section-heading.component.scss',
})
export class FiltersSectionHeadingComponent {
  titleKey = input.required<string>();
  icon = input.required<string>();
}
